import { Tooltip as MuiTooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { tooltipClasses } from '@mui/material/Tooltip'

import { forwardRef } from 'react'

export const Tooltip = forwardRef((props, ref) => {
    const Tooltip = styled(({ className, ref, ...props}) => (
        <MuiTooltip {...props} classes={{ popper: className }} ref={ref} />
    ))(() => ({ [`& .${tooltipClasses.tooltip}`]: { fontSize: props.size || 14 } }))

    return (
        <Tooltip {...props} ref={ref}>
            {props.children}
        </Tooltip>
    )
})

Tooltip.displayName = 'Tooltip'

export default Tooltip